export default {
  site: {
    name: 'אתר',
    path: 'https://example.com',
  },
  main: {
    name: 'דף ראשי',
    path: '/',
  },
  login: {
    name: 'התחברות',
    path: '/login',
  },
  reset: {
    name: 'איפוס סיסמא',
    path: '/password_reset/:uuid',
  },
  forgot: {
    name: 'שכחתי סיסמא',
    path: '/forgot',
  },
  agencyCommissions: {
    name: 'עמלות סוכנות',
    path: '/agencyCommissions',
  },
  agencyCommissionsCreate: {
    name: 'יצירת עמלות סוכנות',
    path: '/agencyCommissions/create',
  },
  agencyCommissionsView: {
    name: 'צפייה בעמלות סוכנות',
    path: '/agencyCommissions/view/:id',
  },
  agencyCommissionsEdit: {
    name: 'עריכת עמלות סוכנות',
    path: '/agencyCommissions/edit/:id',
  },
  agents: {
    name: 'סוכנים',
    path: '/agents',
  },
  files: {
    name: 'קבצים',
    path: '/files',
  },
  agentsArchived: {
    name: 'ארכיון סוכנים',
    path: '/archived',
  },
  agentEdit: {
    name: 'עריכת סוכן',
    path: '/agents/edit/:id/:tab?',
  },
  agentCreate: {
    name: 'יצירת סוכן',
    path: '/agents/create',
  },
  agentView: {
    name: 'צפייה בסוכן',
    path: '/agents/view/:id/:tab?/:state?/:status?',
  },
  settings: {
    name: 'הגדרות',
    path: '/settings',
  },
  reports: {
    name: 'דוחות',
    path: '/reports',
  },
  reportList: {
    name: 'דוח סוכן',
    path: '/reports/list/:reportId',
  },
  reportsView: {
    name: 'דוח סוכן',
    path: '/reports/view/:id/:query',
  },
  monthlyPayment: {
    name: 'התחשבנות ',
    path: '/monthlyPayment',
  },
  viewMonthlyPayment: {
    name: 'התחשבנות חודשית עם סוכן',
    path: '/monthlyPaymentView/:id/:query',
  },
  users: {
    name: 'משתמשים',
    path: '/users',
  },
  userEdit: {
    name: 'עריכת משתמש',
    path: '/users/edit/:id',
  },
  userCreate: {
    name: 'יצירת משתמש',
    path: '/users/create',
  },
  userView: {
    name: 'צפייה במשתמש',
    path: '/users/view/:id',
  },
  messages: {
    name: 'הודעות',
    path: '/messages',
  },
  uploads: {
    name: 'קבצים',
    path: '/uploads',
  },
  imports: {
    name: 'טעינת נתונים',
    path: '/imports',
  },
  manualImports: {
    name: 'הזנה ידנית',
    path: '/imports/manual',
  },
  archiveExpenses: {
    name: 'ארכיון הוצאות',
    path: '/archiveExpenses/:id',
  },
  archiveFees: {
    name: 'ארכיון תשלומים נוספים',
    path: '/archiveFees/:id',
  },
  archiveEmails: {
    name: 'ארכיון מיילים',
    path: '/archiveEmails/:id',
  },
  paymentConfirm: {
    name: 'אסמכתאות',
    path: '/paymentConfirmation',
  },
  fileCommissionDeviations: {
    name: 'סטיות עמלות קבצים',
    path: '/fileCommissionDeviations',
  },
  events: { name: 'אירועים', path: '/events' },
};
